// extracted by mini-css-extract-plugin
export default {"brandIcon":"brandIcon_brandIcon__4IzFQ"};